import App from '@/models/App'

export default class ShipLaborDashboard extends App {
    static get entity() {
        return 'ShipLaborDashboard'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static findByDate(date) {
        return this.query().where('attendanceAt', date).first()
    }
    static fields() {
        return {
            laborDashboard: this.attr([]),
        }
    }
    static apiConfig = {
        actions: {
            fetch(shipId, params) {
                return this.get(`${shipId}/labor/dashboard`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
